module.exports = __webpack_public_path__ + "static/media/Pouť-97-korunovace0.0dc6c62c.jpg";